import React from 'react';

function CheckupProtectionLegal() {
    return (
        <React.Fragment>
            <h6>ΟΡΟΙ ΧΡΗΣΗΣ ΕΝΕΡΓΕΙΑΚΗΣ ΥΠΗΡΕΣΙΑΣ ENERGY CHECKUP</h6>
            <ul style={{listStyleType: "none"}}>
                <li>1. Η υπηρεσία αφορά στη διενέργεια ενεργειακού ελέγχου (Energy checkup) σε αυτοτελή κατοικία. Η
                    υπηρεσία έχει ως σκοπό την παροχή πληροφοριών προς τον πελάτη στο πλαίσιο βελτίωσης της ενεργειακής
                    αποδοτικότητας της κατοικίας του, της μείωσης του ενεργειακού κόστους του πελάτη, καθώς και της
                    μείωσης των περιβαλλοντικών επιπτώσεων από την χρήση της εγκατάστασης. Παρέχει στον πελάτη, που
                    αποδέχεται να κάνει χρήση της υπηρεσίας πληροφόρηση για το τρέχον επίπεδο της ενεργειακής
                    αποδοτικότητας της κατοικίας του, για τις διαθέσιμες βέλτιστες πρακτικές, καθώς επίσης και
                    προσωποποιημένη πληροφόρηση, που συνοδεύεται από προτεινόμενες λύσεις για την κατοικία του.
                </li>
                <li>2. Η υπηρεσία δεν αφορά στην έκδοση πιστοποιητικού ενεργειακής απόδοσης (ΠΕΑ).</li>
                <li>3. Η υπηρεσία παρέχεται μόνο σε πελάτες της ZeniΘ με ενεργή σύμβαση παροχής φυσικού αερίου, ή
                    ηλεκτρικής ενέργειας.
                </li>
                <li>4. Η υπηρεσία παρέχεται εφάπαξ, ανά κατοικία. Σε περίπτωση πακέτου dual energy, παρέχεται μία φορά,
                    ανεξαρτήτως της ταυτόχρονης ύπαρξης ενεργού σύμβασης προμήθειας φυσικού αερίου και ηλεκτρισμού.
                </li>
                <li>5. Η παροχή της συγκεκριμένης υπηρεσίας από την ZeniΘ είναι προαιρετική.</li>
                <li>6. Το κόστος παροχής της υπηρεσίας ανέρχεται στο ποσό των 30,00€, συμπεριλαμβανομένου του ΦΠΑ.</li>
                <li>7. Η υπηρεσία θα παρέχεται άνευ ανταλλάγματος στον πελάτη από τη ΖeniΘ μέχρι και την 31<sup>η</sup>.12.{new Date().getFullYear()}.
                    Ωστόσο, το κόστος της υπηρεσίας θα αναγράφεται αναλυτικά στον λογαριασμό φυσικού αερίου ή ηλεκτρικής
                    ενέργειας του πελάτη που αποδέχθηκε να κάνει χρήση αυτής και ακολούθως θα αναγράφεται ότι
                    παρασχέθηκε με έκπτωση 100%.
                </li>
                <li>8. Η παροχή της υπηρεσίας είναι διαθέσιμη μόνον κατόπιν εκδόσεως κωδικού ενεργειακής υπηρεσίας από
                    την ZeniΘ. Η έκδοση του κωδικού πραγματοποιείται με τους εξής τρόπους: α) Μέσω της εταιρικής
                    ιστοσελίδας της ZeniΘ (<a href={"www.zenith.gr"}>www.zenith.gr</a>), β) με κλήση στον τηλεφωνικό
                    κέντρο εξυπηρέτησης πελατών της ZeniΘ (αριθμός 18321), γ) στα γραφεία εξυπηρέτησης πελατών της
                    ZeniΘ.
                </li>
                <li>9. Η έκδοση κωδικού ενεργειακής υπηρεσίας δεν συνεπάγεται τιμολόγηση για την παροχή της υπηρεσίας
                    αυτής. Η τιμολόγηση της υπηρεσίας πραγματοποιείται εφόσον η υπηρεσία έχει παρασχεθεί.
                </li>
                <li>10. Η υπηρεσία παρέχεται από την ZeniΘ μέσω δικτύου συμβεβλημένων συνεργατών της ZeniΘ. Τα στοιχεία
                    των συμβεβλημένων συνεργατών για την παροχή της υπηρεσίας αναρτώνται στην εταιρική ιστοσελίδα της
                    ZeniΘ.
                </li>
                <li>11. Ο πελάτης της ZeniΘ έχει δικαίωμα ελεύθερης επιλογής συνεργάτη για την παροχή της υπηρεσίας, υπό
                    την προϋπόθεση ότι ο επιλεγμένος συνεργάτης υποστηρίζει την περιοχή στην οποία βρίσκεται η κατοικία
                    του πελάτη.
                </li>
                <li>12. Ο πελάτης συνεννοείται απευθείας με τον συνεργάτη της επιλογής του για την ημερομηνία παροχής
                    της υπηρεσίας, αφού προηγουμένως έχει λάβει τον απαραίτητο κωδικό από την ZeniΘ. Ο πελάτης οφείλει
                    να ενημερώσει τον συνεργάτη ότι είναι κάτοχος του εν λόγω κωδικού.
                </li>
                <li>13. Μετά το πέρας των εργασιών, ο συνεργάτης παραδίδει στον πελάτη συμπληρωμένο Έντυπο Ενεργειακού
                    Ελέγχου (Energy Checkup), αντίγραφο του οποίου θα παραλαμβάνει και η ΖeniΘ ως επιβεβαίωση της
                    επίσκεψης του τεχνικού αλλά και για στατιστικούς λόγους.
                </li>
                <li>14. Η υπηρεσία έχει καθαρά συμβουλευτικό χαρακτήρα. Τα αποτελέσματα που προκύπτουν, δεν αποτελούν
                    προϊόν ενεργειακής μελέτης και δεν την υποκαθιστούν. Η ZeniΘ δεν ευθύνεται για τυχόν σφάλματα, ή
                    λανθασμένα αποτελέσματα, που μπορεί να προκύψουν από τη χρήση της υπηρεσίας.
                </li>
                <li>15. Ο πελάτης οφείλει να γνωστοποιήσει στην ZeniΘ οποιοδήποτε παράπονο, ή διαμαρτυρία, σε σχέση με
                    την παρεχόμενη υπηρεσία ή/και τον συνεργάτη.
                </li>
                <li>16. Η ZeniΘ διατηρεί το δικαίωμα τροποποίησης των όρων της παρεχόμενης υπηρεσίας, καθώς επίσης και
                    της τιμολογιακής της πολιτικής, σύμφωνα με τις επιχειρησιακές της ανάγκες.
                </li>
                <li>17. Η ZeniΘ διατηρεί το δικαίωμα, κατά την απόλυτη κρίση της, οποτεδήποτε, δίχως κάποια προηγούμενη
                    ενημέρωση, να αναστείλει ή/και να διακόψει, την παροχή της αναφερόμενης στους παρόντες όρους
                    υπηρεσίας, αναλόγως προς τις επιχειρησιακές της ανάγκες.
                </li>
                <li>18. Τα Δεδομένα Προσωπικού Χαρακτήρα του πελάτη που αφορούν στην παροχή της συγκεκριμένης υπηρεσίας
                    καθώς και τα δεδομένα του εντύπου ενεργειακού ελέγχου θα τύχουν επεξεργασίας από τη ZeniΘ, καθώς και
                    από τον συνεργάτη που θα έχει επιλέξει ο πελάτης, σύμφωνα με τις διατάξεις της εκάστοτε ισχύουσας
                    Εθνικής και Ενωσιακής Νομοθεσίας που διέπει την προστασία Δεδομένων Προσωπικού Χαρακτήρα
                    περιλαμβανομένου του Γενικού Κανονισμού (ΕΕ) 2016/679 για την προστασία των φυσικών προσώπων έναντι
                    της επεξεργασίας των δεδομένων προσωπικού χαρακτήρα. Για περαιτέρω πληροφορίες σχετικά με την
                    επεξεργασία των προσωπικών δεδομένων του πελάτη, ο τελευταίος έχει την δυνατότητα να ενημερωθεί
                    σχετικά από την Πολιτική Απορρήτου της Εταιρείας στον σύνδεσμο <a
                        href={"www.zenith.gr/privacy/"}>www.zenith.gr/privacy/</a>.
                </li>
            </ul>
        </React.Fragment>
    )
}

function MaintenanceProtectionLegal() {
    return (
        <React.Fragment>
            <h6>ΟΡΟΙ ΧΡΗΣΗΣ ΕΝΕΡΓΕΙΑΚΗΣ ΥΠΗΡΕΣΙΑΣ ΣΥΝΤΗΡΗΣΗΣ ΛΕΒΗΤΩΝ</h6>
            <ul style={{listStyleType: "none"}}>
                <li>1. Η υπηρεσία αφορά στην ετήσια προληπτική συντήρηση λειτουργικών λεβήτων φυσικού αερίου (άνευ
                    βλάβης). Οι εργασίες προληπτικής συντήρησης λεβήτων αερίου αφορούν μόνο επίτοιχους λέβητες αερίου με
                    μέγιστη αποδιδόμενη θερμική ισχύ έως 50 kW.
                </li>
                <li>2. Η υπηρεσία παρέχεται μόνο σε πελάτες της ZeniΘ με ενεργή παροχή φυσικού αερίου.</li>
                <li>3. Η παροχή της συγκεκριμένης υπηρεσίας από την ZeniΘ είναι προαιρετική.</li>
                <li>4. Η υπηρεσία παρέχεται επ’ αμοιβή που τιμολογείται από την ZeniΘ στους λογαριασμούς φυσικού αερίου
                    του πελάτη που έκανε χρήση της υπηρεσίας.
                </li>
                <li>5. Το κόστος παροχής της υπηρεσίας ανέρχεται στο ποσό των 59,88€ ανά συντήρηση, συμπεριλαμβανόμενου του ΦΠΑ.
                </li>
                <li>6. Το κόστος παροχής της υπηρεσίας επιμερίζεται αναλογικά σε χρονικό διάστημα ενός (1) έτους από την
                    λήψη της υπηρεσίας. Ως βάση επιμερισμού λαμβάνεται η ημερολογιακή ημέρα. Η υπηρεσία τιμολογείται
                    στους λογαριασμούς φυσικού αερίου, αναλογικά με τις μέρες της περιόδου κατανάλωσης που αφορά ο
                    εκάστοτε λογαριασμός.
                </li>
                <li>7. Η παροχή της υπηρεσίας είναι διαθέσιμη μόνον κατόπιν εκδόσεως κωδικού ενεργειακής υπηρεσίας από
                    την ZeniΘ. Η έκδοση του κωδικού πραγματοποιείται με τους εξής τρόπους: α) Μέσω της εταιρικής
                    ιστοσελίδας της ZeniΘ (<a href={"www.zenith.gr"}>www.zenith.gr</a>), β) με κλήση στο τηλεφωνικό
                    κέντρο εξυπηρέτησης πελατών της ZeniΘ (αριθμός 18321), γ) στα γραφεία εξυπηρέτησης πελατών της
                    ZeniΘ.
                </li>
                <li>8. Η έκδοση κωδικού ενεργειακής υπηρεσίας δεν συνεπάγεται τιμολόγηση για την παροχή της υπηρεσίας
                    αυτής. Η τιμολόγηση της υπηρεσίας πραγματοποιείται μετά την λήψη της υπηρεσίας.
                </li>
                <li>9. Η υπηρεσία παρέχεται από την ZeniΘ μέσω δικτύου συμβεβλημένων συνεργατών της ZeniΘ. Τα στοιχεία
                    των συμβεβλημένων συνεργατών για την παροχή της υπηρεσίας αναρτώνται στην εταιρική ιστοσελίδα της
                    ZeniΘ.
                </li>
                <li>10. Ο πελάτης της ZeniΘ έχει δικαίωμα ελεύθερης επιλογής συνεργάτη για την παροχή της υπηρεσίας, υπό
                    τις εξής προϋποθέσεις: α) ο επιλεγμένος συνεργάτης υποστηρίζει την περιοχή στην οποία βρίσκεται η
                    εγκατάσταση του πελάτη και β) ο επιλεγμένος συνεργάτης υποστηρίζει τον κατασκευαστή του λέβητα του
                    συνεργάτη.
                </li>
                <li>11. Ο πελάτης συνεννοείται απευθείας με τον συνεργάτη της επιλογής του για την ημερομηνία λήψης της
                    υπηρεσίας, αφού προηγουμένως έχει λάβει τον απαραίτητο κωδικό από την ZeniΘ. Ο πελάτης οφείλει να
                    ενημερώσει τον συνεργάτη ότι είναι κάτοχος του εν λόγω κωδικού.
                </li>
                <li>12. Κατά την επίσκεψη του συνεργάτη στην εγκατάσταση του πελάτη για την παροχή της υπηρεσίας, ο
                    πελάτης υποχρεούται να υπογράψει το έντυπο αποδοχής των όρων της υπηρεσίας, πριν την έναρξη των
                    εργασιών.
                </li>
                <li>13. Ο συνεργάτης, στο πλαίσιο παροχής της υπηρεσίας, υποχρεούται, να ενημερώσει τον πελάτη για τις
                    εργασίες στις οποίες πρόκειται να προβεί, κατόπιν ρητής αποδοχή του πελάτη και ακολούθως να
                    υλοποιήσει κατ’ ελάχιστο τις παρακάτω εργασίες: Άδειασμα νερού από λέβητα, Καθαρισμό καυστήρα,
                    Καθαρισμό θαλάμου καύσης (πρωτεύων εναλλάκτης), Πλύσιμο δευτερεύοντος εναλλάκτη εφόσον απαιτείται,
                    Έλεγχο του αέρα στο δοχείο διαστολής, Έλεγχο υδραυλικής ομάδας λέβητα (τρίοδη, by-bass, φίλτρα),
                    Έλεγχο λειτουργίας ασφαλιστικών διατάξεων, Πλήρωση και εξαέρωση λέβητα, Έλεγχο πίεσης αερίου,
                    Ρύθμιση καύσης με αναλυτή καυσαερίων, Έλεγχο ποιότητας νερού εγκατάστασης θέρμανσης. Στις ανωτέρω
                    εργασίες συμπεριλαμβάνονται όλα τα απαιτούμενα αναλώσιμα υλικά. Στο πλαίσιο της παρεχόμενης
                    υπηρεσίας δεν συμπεριλαμβάνονται ανταλλακτικά και εργασία τοποθέτησής τους. Μετά το πέρας των
                    εργασιών, ο συνεργάτης παραδίδει στον πελάτη τυποποιημένο φύλλο συντήρησης, σύμφωνα με τη νομοθεσία.
                </li>
                <li>14. Ο συνεργάτης ευθύνεται για τις πράξεις ή/και παραλείψεις, καθώς και για κάθε ζημία, βλάβη τυχόν
                    προξενήσει στις εγκαταστάσεις και τον εξοπλισμό του πελάτη κατά την υλοποίηση της υπηρεσίας. Σε
                    περίπτωση πλημμελούς παροχής της υπηρεσίας και πρόκλησης ζημίας στον πελάτη, ο συνεργάτης
                    υποχρεούται στην ανόρθωση της ζημίας που θα υποστεί ο πελάτης.
                </li>
                <li>15. Ο πελάτης οφείλει να γνωστοποιήσει στην ZeniΘ οποιοδήποτε παράπονο, ή διαμαρτυρία, σε σχέση με
                    την παρεχόμενη υπηρεσία ή/και τον συνεργάτη.
                </li>
                <li>16. Η ZeniΘ διατηρεί το δικαίωμα τροποποίησης των όρων της παρεχόμενης υπηρεσίας, καθώς επίσης και
                    της τιμολογιακής της πολιτικής, σύμφωνα με τις επιχειρησιακές της ανάγκες.
                </li>
                <li>17. Η ZeniΘ διατηρεί το δικαίωμα, κατά την απόλυτη κρίση της, οποτεδήποτε, δίχως κάποια προηγούμενη
                    ενημέρωση, να αναστείλει ή/και να διακόψει, την παροχή της αναφερόμενης στους παρόντες όρους
                    υπηρεσίας, αναλόγως προς τις επιχειρησιακές της ανάγκες.
                </li>
                <li>18. Η ZeniΘ διατηρεί το δικαίωμα ανάκτησης του υπολειπόμενου κόστους της παρασχεθησόμενης υπηρεσίας
                στην περίπτωση που ο πελάτης υποβάλλει αίτημα εκπροσώπησης σε άλλο πάροχο πριν παρέλθει η συνολική
                αποπληρωμή του κόστους της παρεχόμενης υπηρεσίας
                </li>
                <li>19.Τα Δεδομένα Προσωπικού Χαρακτήρα του πελάτη που αφορούν στην παροχή της συγκεκριμένης
                υπηρεσίας θα τύχουν επεξεργασίας από τη ZeniΘ  καθώς και από τον συνεργάτη, μετά από τηλεφωνική
                επικοινωνία του πελάτη με τον τελευταίο, για τον σκοπό παροχής της υπηρεσίας, σύμφωνα με τις διατάξεις
                της εκάστοτε ισχύουσας Εθνικής και Ενωσιακής Νομοθεσίας που διέπει την προστασία Δεδομένων 
                Προσωπικού Χαρακτήρα περιλαμβανομένου του Γενικού Κανονισμού (ΕΕ) 2016/679 για την προστασία των
                φυσικών προσώπων έναντι της επεξεργασίας των δεδομένων προσωπικού χαρακτήρα. Για περαιτέρω 
                πληροφορίες σχετικά με την επεξεργασία των προσωπικών δεδομένων του πελάτη, ο τελευταίος έχει την
                δυνατότητα να ενημερωθεί σχετικά από την Πολιτική Απορρήτου της Εταιρείας στον σύνδεσμο
                <a href={"www.zenith.gr/privacy/"}>www.zenith.gr/privacy/</a> .
                </li>
            </ul>
        </React.Fragment>
    )
}

function PeaProtectionLegal() {
    return (
        <React.Fragment>
            <h6>ΟΡΟΙ ΧΡΗΣΗΣ ΕΝΕΡΓΕΙΑΚΗΣ ΥΠΗΡΕΣΙΑΣ ΕΚΔΟΣΗΣ ΠΙΣΤΟΠΟΙΗΤΙΚΟΥ ΕΝΕΡΓΕΙΑΚΗΣ ΑΠΟΔΟΣΗΣ (Π.Ε.Α.)</h6>
            <ul style={{listStyleType: "none"}}>
                <li>
                    1. Η υπηρεσία αφορά την έκδοση Πιστοποιητικού
                    Ενεργειακής Απόδοσης (Π.Ε.Α.), σύμφωνα με τον
                    Κανονισμό Ενεργειακής Απόδοσης Κτιρίων (Κ.Εν.Α.Κ.).
                </li>
                <li>
                    2. Η υπηρεσία αφορά αποκλειστικά κατοικίες.
                </li>
                <li>
                    3. Η υπηρεσία παρέχεται μόνο σε πελάτες της ZeniΘ με
                    ενεργή σύμβαση παροχής φυσικού αερίου, ή ηλεκτρικής
                    ενέργειας.
                </li>
                <li>
                    4. Η παροχή της συγκεκριμένης υπηρεσίας από την ZeniΘ
                    είναι προαιρετική.
                </li>
                <li>
                    5. Η υπηρεσία παρέχεται επ’ αμοιβή που τιμολογείται από
                    την ZeniΘ στους λογαριασμούς φυσικού αερίου ή
                    ηλεκτρικής ενέργειας του πελάτη που έκανε χρήση της
                    υπηρεσίας.
                </li>
                <li>
                    6. Το κόστος παροχής της υπηρεσίας ανέρχεται στο ποσό
                    των 83,88€, ανά υπηρεσία, συμπεριλαμβανομένου του
                    ΦΠΑ.
                </li>
                <li>
                    7. Σε περίπτωση που ο πελάτης δεν διαθέτει κάτοψη
                    (σχέδιο) της κατοικίας, το κόστος παροχής της υπηρεσίας
                    ανέρχεται στο ποσό των 107,88€, ανά υπηρεσία,
                    συμπεριλαμβανομένου του ΦΠΑ.
                </li>
                <li>
                    8. Το κόστος παροχής της υπηρεσίας επιμερίζεται
                    αναλογικά σε χρονικό διάστημα ενός (1) έτους από την
                    λήψη της υπηρεσίας. Ως βάση επιμερισμού λαμβάνεται
                    η ημερολογιακή ημέρα. Η υπηρεσία τιμολογείται στους
                    λογαριασμούς φυσικού αερίου ή ηλεκτρικής ενέργειας,
                    αναλογικά με τις μέρες της περιόδου κατανάλωσης που
                    αφορά ο εκάστοτε λογαριασμός.
                </li>
                <li>
                    9. Η παροχή της υπηρεσίας είναι διαθέσιμη μόνον κατόπιν
                    εκδόσεως κωδικού ενεργειακής υπηρεσίας από την
                    ZeniΘ. Η έκδοση του κωδικού πραγματοποιείται με τους
                    εξής τρόπους: α) Μέσω της εταιρικής ιστοσελίδας της
                    ZeniΘ (<a href={"www.zenith.gr"}>www.zenith.gr</a>), β) με κλήση στο τηλεφωνικό
                    κέντρο εξυπηρέτησης πελατών της ZeniΘ (αριθμός
                    18321), γ) στα καταστήματα εξυπηρέτησης πελατών της
                    ZeniΘ.
                </li>
                <li>
                    10. Η έκδοση κωδικού ενεργειακής υπηρεσίας δεν
                    συνεπάγεται τιμολόγηση για την παροχή της υπηρεσίας
                    αυτής. Η τιμολόγηση της υπηρεσίας πραγματοποιείται
                    μετά την λήψη της υπηρεσίας.
                </li>
                <li>
                    11. Η υπηρεσία παρέχεται από την ZeniΘ μέσω
                    πιστοποιημένου συνεργάτη της ZeniΘ.
                </li>
                <li>
                    12. Ο πελάτης επικοινωνεί με το τηλεφωνικό κέντρο του
                    συνεργάτη, ενημερώνεται για τα απαιτούμενα
                    δικαιολογητικά και συνεννοείται για την ημερομηνία
                    λήψης της υπηρεσίας, αφού προηγουμένως έχει λάβει
                    τον απαραίτητο κωδικό από την ZeniΘ. Ο πελάτης
                    οφείλει να ενημερώσει τον συνεργάτη ότι είναι κάτοχος
                    του εν λόγω κωδικού.
                </li>
                <li>
                    13. Κατά την επίσκεψη του συνεργάτη στην εγκατάσταση
                    του πελάτη για την παροχή της υπηρεσίας, ο πελάτης
                    υποχρεούται να υπογράψει το έντυπο αποδοχής των
                    όρων της υπηρεσίας, πριν την έναρξη των εργασιών.
                </li>
                <li>
                    14. Ο συνεργάτης, στο πλαίσιο παροχής της υπηρεσίας,
                    υποχρεούται, να ενημερώσει τον πελάτη για τις εργασίες
                    στις οποίες πρόκειται να προβεί, κατόπιν ρητής
                    αποδοχής του πελάτη και ακολούθως να υλοποιήσει κατ’
                    ελάχιστο τις παρακάτω εργασίες: Διενέργεια
                    ενεργειακής επιθεώρησης της κτιριακής εγκατάστασης
                    προκειμένου να πιστοποιηθεί η ενεργειακή
                    αποδοτικότητα αυτής, συμπεριλαμβανομένων όλων των
                    απαραίτητων μετρήσεων, ελέγχων και υπολογισμών που
                    απαιτούνται στο πλαίσιο έκδοσης του Π.Ε.Α. Μετά το
                    πέρας των εργασιών, ο συνεργάτης παραδίδει στον
                    πελάτη τυποποιημένο Πιστοποιητικό Ενεργειακής
                    Απόδοσης (Π.Ε.Α.), σύμφωνα με τη νομοθεσία.
                </li>
                <li>
                    15. Ο συνεργάτης ευθύνεται για τις πράξεις ή/και
                    παραλείψεις, καθώς και για κάθε ζημία, βλάβη τυχόν
                    προξενήσει στις εγκαταστάσεις και τον εξοπλισμό του
                    πελάτη κατά την υλοποίηση της υπηρεσίας. Σε
                    περίπτωση πλημμελούς παροχής της υπηρεσίας και
                    πρόκλησης ζημίας στον πελάτη, ο συνεργάτης
                    υποχρεούται στην ανόρθωση της ζημίας που θα υποστεί
                    ο πελάτης.
                </li>
                <li>
                    16. Ο πελάτης οφείλει να γνωστοποιήσει εγγράφως στην
                    ZeniΘ οποιοδήποτε παράπονο, ή διαμαρτυρία, σε σχέση
                    με την παρεχόμενη υπηρεσία ή/και τον συνεργάτη.
                </li>
                <li>
                    17. Η ZeniΘ διατηρεί το δικαίωμα τροποποίησης των όρων
                    της παρεχόμενης υπηρεσίας, καθώς επίσης και της
                    τιμολογιακής της πολιτικής, σύμφωνα με τις
                    επιχειρησιακές της ανάγκες.
                </li>
                <li>
                    18. Η ZeniΘ διατηρεί το δικαίωμα, κατά την απόλυτη κρίση
                    της, οποτεδήποτε, δίχως κάποια προηγούμενη
                    ενημέρωση, να αναστείλει ή/και να διακόψει, την
                    παροχή της αναφερόμενης στους παρόντες όρους
                    υπηρεσίας, αναλόγως προς τις επιχειρησιακές της
                    ανάγκες.
                </li>
                <li>
                    19. Η ZeniΘ διατηρεί το δικαίωμα ανάκτησης του
                    υπολειπόμενου κόστους της παρασχεθησόμενης
                    υπηρεσίας στην περίπτωση που ο πελάτης υποβάλλει
                    αίτημα εκπροσώπησης σε άλλο πάροχο πριν παρέλθει η
                    συνολική αποπληρωμή του κόστους της παρεχόμενης
                    υπηρεσίας.
                </li>
                <li>
                    20. Τα Δεδομένα Προσωπικού Χαρακτήρα του πελάτη που
                    αφορούν στην παροχή της συγκεκριμένης υπηρεσίας θα
                    τύχουν επεξεργασίας από τη ZeniΘ καθώς και από τον
                    συνεργάτη, μετά από τηλεφωνική επικοινωνία του
                    πελάτη με τον τελευταίο, για τον σκοπό παροχής της
                    υπηρεσίας, σύμφωνα με τις διατάξεις της εκάστοτε
                    ισχύουσας Εθνικής και Ενωσιακής Νομοθεσίας που
                    διέπει την προστασία Δεδομένων Προσωπικού
                    Χαρακτήρα περιλαμβανομένου του Γενικού Κανονισμού
                    (ΕΕ) 2016/679 για την προστασία των φυσικών
                    προσώπων έναντι της επεξεργασίας των δεδομένων
                    προσωπικού χαρακτήρα. Για περαιτέρω πληροφορίες
                    σχετικά με την επεξεργασία των προσωπικών δεδομένων
                    του πελάτη, ο τελευταίος έχει την δυνατότητα να
                    ενημερωθεί σχετικά από την Πολιτική Απορρήτου της
                    Εταιρείας στον σύνδεσμο <a href={"www.zenith.gr/privacy/"}>www.zenith.gr/privacy/</a> .
                </li>
            </ul>
        </React.Fragment>
    )
}

function YdeProtectionLegal() {
    return (
        <React.Fragment>
            <h6>ΟΡΟΙ ΧΡΗΣΗΣ ΕΝΕΡΓΕΙΑΚΗΣ ΥΠΗΡΕΣΙΑΣ ΧΟΡΗΓΗΣΗΣ ΗΛΕΚΤΡΟΛΟΓΙΚΟΥ ΣΧΕΔΙΟΥ (Υ.Δ.Ε.)</h6>
            <ul style={{listStyleType: "none"}}>
                <li>1. Η υπηρεσία αφορά την χορήγηση Υπεύθυνης Δήλωσης
                    Εγκαταστάτη (Υ.Δ.Ε.) εσωτερικής Ηλεκτρολογικής
                    Εγκατάστασης, σύμφωνα με την Υπουργική Απόφαση
                    υπ. αριθ. Φ.50/503/168/19.04.2011 (ΦΕΚ Β’
                    844/16.05.2011).
                </li>
                <li>2. Η υπηρεσία αφορά αποκλειστικά εσωτερικές
                    ηλεκτρολογικές εγκαταστάσεις κατοικιών.
                </li>
                <li>3. Η υπηρεσία παρέχεται μόνο σε πελάτες της ZeniΘ με
                    ενεργή σύμβαση παροχής φυσικού αερίου, ή ηλεκτρικής
                    ενέργειας.
                </li>
                <li>4. Η παροχή της συγκεκριμένης υπηρεσίας από την ZeniΘ
                    είναι προαιρετική.
                </li>
                <li>5. Η υπηρεσία παρέχεται επ’ αμοιβή που τιμολογείται από
                    την ZeniΘ στους λογαριασμούς φυσικού αερίου ή
                    ηλεκτρικής ενέργειας του πελάτη που έκανε χρήση της
                    υπηρεσίας.
                </li>
                <li>6. Το κόστος παροχής της υπηρεσίας ανέρχεται στο ποσό
                    των 47,88€, ανά υπηρεσία, συμπεριλαμβανομένου του
                    ΦΠΑ.
                </li>
                <li>7. Το κόστος παροχής της υπηρεσίας επιμερίζεται
                    αναλογικά σε χρονικό διάστημα ενός (1) έτους από την
                    λήψη της υπηρεσίας. Ως βάση επιμερισμού λαμβάνεται
                    η ημερολογιακή ημέρα. Η υπηρεσία τιμολογείται στους
                    λογαριασμούς φυσικού αερίου ή ηλεκτρικής ενέργειας,
                    αναλογικά με τις μέρες της περιόδου κατανάλωσης που
                    αφορά ο εκάστοτε λογαριασμός.
                </li>
                <li>8. Η παροχή της υπηρεσίας είναι διαθέσιμη μόνον κατόπιν
                    εκδόσεως κωδικού ενεργειακής υπηρεσίας από την
                    ZeniΘ. Η έκδοση του κωδικού πραγματοποιείται με τους εξής τρόπους: α) Μέσω της εταιρικής ιστοσελίδας της
                    ZeniΘ (<a href={"www.zenith.gr"}>www.zenith.gr</a>), β) με κλήση στο τηλεφωνικό
                    κέντρο εξυπηρέτησης πελατών της ZeniΘ (αριθμός
                    18321), γ) στα καταστήματα εξυπηρέτησης πελατών της
                    ZeniΘ.
                </li>
                <li>9. Η έκδοση κωδικού ενεργειακής υπηρεσίας δεν
                    συνεπάγεται τιμολόγηση για την παροχή της υπηρεσίας
                    αυτής. Η τιμολόγηση της υπηρεσίας πραγματοποιείται
                    μετά την λήψη της υπηρεσίας.
                </li>
                <li>10. Η υπηρεσία παρέχεται από την ZeniΘ μέσω
                    πιστοποιημένου συνεργάτη της ZeniΘ.
                </li>
                <li>11. Ο πελάτης επικοινωνεί με το τηλεφωνικό κέντρο του
                    συνεργάτη και συνεννοείται για την ημερομηνία λήψης
                    της υπηρεσίας, αφού προηγουμένως έχει λάβει τον
                    απαραίτητο κωδικό από την ZeniΘ. Ο πελάτης οφείλει να
                    ενημερώσει τον συνεργάτη ότι είναι κάτοχος του εν λόγω
                    κωδικού.
                </li>
                <li>12. Κατά την επίσκεψη του συνεργάτη στην εγκατάσταση
                    του πελάτη για την παροχή της υπηρεσίας, ο πελάτης
                    υποχρεούται να υπογράψει το έντυπο αποδοχής των
                    όρων της υπηρεσίας, πριν την έναρξη των εργασιών.
                </li>
                <li>13. Ο συνεργάτης, στο πλαίσιο παροχής της υπηρεσίας,
                    υποχρεούται, να ενημερώσει τον πελάτη για τις εργασίες
                    στις οποίες πρόκειται να προβεί, κατόπιν ρητής
                    αποδοχής του πελάτη και ακολούθως να υλοποιήσει κατ’
                    ελάχιστο τις παρακάτω εργασίες: Διενέργεια ελέγχου
                    ή επανελέγχου της εσωτερικής ηλεκτρικής εγκατάστασης
                    προκειμένου να πιστοποιήσει την ασφαλή και
                    απρόσκοπτη λειτουργία αυτής, συμπεριλαμβανομένων
                    όλων των απαραίτητων μετρήσεων και ελέγχων που
                    απαιτούνται στο πλαίσιο έκδοσης της Υ.Δ.Ε. Μετά το
                    πέρας των εργασιών, ο συνεργάτης παραδίδει στον
                    πελάτη τυποποιημένο φύλλο Υ.Δ.Ε. εσωτερικής
                    Ηλεκτρολογικής Εγκατάστασης, σύμφωνα με τη
                    νομοθεσία.
                </li>
                <li>14. Ο συνεργάτης ευθύνεται για τις πράξεις ή/και
                    παραλείψεις, καθώς και για κάθε ζημία, βλάβη τυχόν
                    προξενήσει στις εγκαταστάσεις και τον εξοπλισμό του
                    πελάτη κατά την υλοποίηση της υπηρεσίας. Σε
                    περίπτωση πλημμελούς παροχής της υπηρεσίας και
                    πρόκλησης ζημίας στον πελάτη, ο συνεργάτης
                    υποχρεούται στην ανόρθωση της ζημίας που θα υποστεί
                    ο πελάτης.
                </li>
                <li>15. Ο πελάτης οφείλει να γνωστοποιήσει εγγράφως στην
                    ZeniΘ οποιοδήποτε παράπονο, ή διαμαρτυρία, σε σχέση
                    με την παρεχόμενη υπηρεσία ή/και τον συνεργάτη.
                </li>
                <li>16. Η ZeniΘ διατηρεί το δικαίωμα τροποποίησης των όρων
                    της παρεχόμενης υπηρεσίας, καθώς επίσης και της
                    τιμολογιακής της πολιτικής, σύμφωνα με τις
                    επιχειρησιακές της ανάγκες
                </li>
                <li>17. Η ZeniΘ διατηρεί το δικαίωμα, κατά την απόλυτη κρίση
                    της, οποτεδήποτε, δίχως κάποια προηγούμενη
                    ενημέρωση, να αναστείλει ή/και να διακόψει, την
                    παροχή της αναφερόμενης στους παρόντες όρους
                    υπηρεσίας, αναλόγως προς τις επιχειρησιακές της
                    ανάγκες.
                </li>
                <li>18. Η ZeniΘ διατηρεί το δικαίωμα ανάκτησης του
                    υπολειπόμενου κόστους της παρασχεθησόμενης
                    υπηρεσίας στην περίπτωση που ο πελάτης υποβάλλει
                    αίτημα εκπροσώπησης σε άλλο πάροχο πριν παρέλθει η
                    συνολική αποπληρωμή του κόστους της παρεχόμενης
                    υπηρεσίας.
                </li>
                <li>19. Τα Δεδομένα Προσωπικού Χαρακτήρα του πελάτη που
                    αφορούν στην παροχή της συγκεκριμένης υπηρεσίας θα
                    τύχουν επεξεργασίας από τη ZeniΘ καθώς και από τον
                    συνεργάτη, μετά από τηλεφωνική επικοινωνία του
                    πελάτη με τον τελευταίο, για τον σκοπό παροχής της
                    υπηρεσίας, σύμφωνα με τις διατάξεις της εκάστοτε 
                    ισχύουσας Εθνικής και Ενωσιακής Νομοθεσίας που
                    διέπει την προστασία Δεδομένων Προσωπικού
                    Χαρακτήρα περιλαμβανομένου του Γενικού Κανονισμού
                    (ΕΕ) 2016/679 για την προστασία των φυσικών
                    προσώπων έναντι της επεξεργασίας των δεδομένων
                    προσωπικού χαρακτήρα. Για περαιτέρω πληροφορίες
                    σχετικά με την επεξεργασία των προσωπικών δεδομένων
                    του πελάτη, ο τελευταίος έχει την δυνατότητα να
                    ενημερωθεί σχετικά από την Πολιτική Απορρήτου της
                    Εταιρείας στον σύνδεσμο <a href={"www.zenith.gr/privacy/"}>www.zenith.gr/privacy/</a> .
                </li>
            </ul>
        </React.Fragment>
    )
}

function YdeProtectionLegalNew() {
    return (
        <React.Fragment>
            <h6>ΟΡΟΙ ΧΡΗΣΗΣ ΕΝΕΡΓΕΙΑΚΗΣ ΥΠΗΡΕΣΙΑΣ ΧΟΡΗΓΗΣΗΣ ΗΛΕΚΤΡΟΛΟΓΙΚΟΥ ΣΧΕΔΙΟΥ (Υ.Δ.Ε.)</h6>
            <ul style={{ listStyleType: "none" }}>
                <li>1. Η υπηρεσία αφορά την χορήγηση Υπεύθυνης Δήλωσης
                    Εγκαταστάτη (Υ.Δ.Ε.) εσωτερικής Ηλεκτρολογικής
                    Εγκατάστασης, σύμφωνα με την Υπουργική Απόφαση
                    υπ. αριθ. Φ.50/503/168/19.04.2011 (ΦΕΚ Β’
                    844/16.05.2011).
                </li>
                <li>2. Η υπηρεσία αφορά αποκλειστικά εσωτερικές
                    ηλεκτρολογικές εγκαταστάσεις κατοικιών.
                </li>
                <li>3. Η υπηρεσία παρέχεται μόνο σε πελάτες της ZeniΘ με
                    ενεργή σύμβαση παροχής φυσικού αερίου, ή ηλεκτρικής
                    ενέργειας.
                </li>
                <li>4. Η παροχή της συγκεκριμένης υπηρεσίας από την ZeniΘ
                    είναι προαιρετική.
                </li>
                <li>5. Η υπηρεσία παρέχεται επ’ αμοιβή που τιμολογείται από
                    την ZeniΘ στους λογαριασμούς φυσικού αερίου ή
                    ηλεκτρικής ενέργειας του πελάτη που έκανε χρήση της
                    υπηρεσίας.
                </li>
                <li>6. Το κόστος παροχής της υπηρεσίας ανέρχεται στο ποσό
                    των 59,88€, ανά υπηρεσία, συμπεριλαμβανομένου του
                    ΦΠΑ.
                </li>
                <li>7. Το κόστος παροχής της υπηρεσίας επιμερίζεται
                    αναλογικά σε χρονικό διάστημα ενός (1) έτους από την
                    λήψη της υπηρεσίας. Ως βάση επιμερισμού λαμβάνεται
                    η ημερολογιακή ημέρα. Η υπηρεσία τιμολογείται στους
                    λογαριασμούς φυσικού αερίου ή ηλεκτρικής ενέργειας,
                    αναλογικά με τις μέρες της περιόδου κατανάλωσης που
                    αφορά ο εκάστοτε λογαριασμός.
                </li>
                <li>8. Η παροχή της υπηρεσίας είναι διαθέσιμη μόνον κατόπιν
                    εκδόσεως κωδικού ενεργειακής υπηρεσίας από την
                    ZeniΘ. Η έκδοση του κωδικού πραγματοποιείται με τους εξής τρόπους: α) Μέσω της εταιρικής ιστοσελίδας της
                    ZeniΘ (<a href={"www.zenith.gr"}>www.zenith.gr</a>), β) με κλήση στο τηλεφωνικό
                    κέντρο εξυπηρέτησης πελατών της ZeniΘ (αριθμός
                    18321), γ) στα καταστήματα εξυπηρέτησης πελατών της
                    ZeniΘ.
                </li>
                <li>9. Η έκδοση κωδικού ενεργειακής υπηρεσίας δεν
                    συνεπάγεται τιμολόγηση για την παροχή της υπηρεσίας
                    αυτής. Η τιμολόγηση της υπηρεσίας πραγματοποιείται
                    μετά την λήψη της υπηρεσίας.
                </li>
                <li>10. Η υπηρεσία παρέχεται από την ZeniΘ μέσω
                    πιστοποιημένου συνεργάτη της ZeniΘ.
                </li>
                <li>11. Ο πελάτης επικοινωνεί με το τηλεφωνικό κέντρο του
                    συνεργάτη και συνεννοείται για την ημερομηνία λήψης
                    της υπηρεσίας, αφού προηγουμένως έχει λάβει τον
                    απαραίτητο κωδικό από την ZeniΘ. Ο πελάτης οφείλει να
                    ενημερώσει τον συνεργάτη ότι είναι κάτοχος του εν λόγω
                    κωδικού.
                </li>
                <li>12. Κατά την επίσκεψη του συνεργάτη στην εγκατάσταση
                    του πελάτη για την παροχή της υπηρεσίας, ο πελάτης
                    υποχρεούται να υπογράψει το έντυπο αποδοχής των
                    όρων της υπηρεσίας, πριν την έναρξη των εργασιών.
                </li>
                <li>13. Ο συνεργάτης, στο πλαίσιο παροχής της υπηρεσίας,
                    υποχρεούται, να ενημερώσει τον πελάτη για τις εργασίες
                    στις οποίες πρόκειται να προβεί, κατόπιν ρητής
                    αποδοχής του πελάτη και ακολούθως να υλοποιήσει κατ’
                    ελάχιστο τις παρακάτω εργασίες: Διενέργεια ελέγχου
                    ή επανελέγχου της εσωτερικής ηλεκτρικής εγκατάστασης
                    προκειμένου να πιστοποιήσει την ασφαλή και
                    απρόσκοπτη λειτουργία αυτής, συμπεριλαμβανομένων
                    όλων των απαραίτητων μετρήσεων και ελέγχων που
                    απαιτούνται στο πλαίσιο έκδοσης της Υ.Δ.Ε. Μετά το
                    πέρας των εργασιών, ο συνεργάτης παραδίδει στον
                    πελάτη τυποποιημένο φύλλο Υ.Δ.Ε. εσωτερικής
                    Ηλεκτρολογικής Εγκατάστασης, σύμφωνα με τη
                    νομοθεσία.
                </li>
                <li>14. Ο συνεργάτης ευθύνεται για τις πράξεις ή/και
                    παραλείψεις, καθώς και για κάθε ζημία, βλάβη τυχόν
                    προξενήσει στις εγκαταστάσεις και τον εξοπλισμό του
                    πελάτη κατά την υλοποίηση της υπηρεσίας. Σε
                    περίπτωση πλημμελούς παροχής της υπηρεσίας και
                    πρόκλησης ζημίας στον πελάτη, ο συνεργάτης
                    υποχρεούται στην ανόρθωση της ζημίας που θα υποστεί
                    ο πελάτης.
                </li>
                <li>15. Ο πελάτης οφείλει να γνωστοποιήσει εγγράφως στην
                    ZeniΘ οποιοδήποτε παράπονο, ή διαμαρτυρία, σε σχέση
                    με την παρεχόμενη υπηρεσία ή/και τον συνεργάτη.
                </li>
                <li>16. Η ZeniΘ διατηρεί το δικαίωμα τροποποίησης των όρων
                    της παρεχόμενης υπηρεσίας, καθώς επίσης και της
                    τιμολογιακής της πολιτικής, σύμφωνα με τις
                    επιχειρησιακές της ανάγκες
                </li>
                <li>17. Η ZeniΘ διατηρεί το δικαίωμα, κατά την απόλυτη κρίση
                    της, οποτεδήποτε, δίχως κάποια προηγούμενη
                    ενημέρωση, να αναστείλει ή/και να διακόψει, την
                    παροχή της αναφερόμενης στους παρόντες όρους
                    υπηρεσίας, αναλόγως προς τις επιχειρησιακές της
                    ανάγκες.
                </li>
                <li>18. Η ZeniΘ διατηρεί το δικαίωμα ανάκτησης του
                    υπολειπόμενου κόστους της παρασχεθησόμενης
                    υπηρεσίας στην περίπτωση που ο πελάτης υποβάλλει
                    αίτημα εκπροσώπησης σε άλλο πάροχο πριν παρέλθει η
                    συνολική αποπληρωμή του κόστους της παρεχόμενης
                    υπηρεσίας.
                </li>
                <li>19. Τα Δεδομένα Προσωπικού Χαρακτήρα του πελάτη που
                    αφορούν στην παροχή της συγκεκριμένης υπηρεσίας θα
                    τύχουν επεξεργασίας από τη ZeniΘ καθώς και από τον
                    συνεργάτη, μετά από τηλεφωνική επικοινωνία του
                    πελάτη με τον τελευταίο, για τον σκοπό παροχής της
                    υπηρεσίας, σύμφωνα με τις διατάξεις της εκάστοτε
                    ισχύουσας Εθνικής και Ενωσιακής Νομοθεσίας που
                    διέπει την προστασία Δεδομένων Προσωπικού
                    Χαρακτήρα περιλαμβανομένου του Γενικού Κανονισμού
                    (ΕΕ) 2016/679 για την προστασία των φυσικών
                    προσώπων έναντι της επεξεργασίας των δεδομένων
                    προσωπικού χαρακτήρα. Για περαιτέρω πληροφορίες
                    σχετικά με την επεξεργασία των προσωπικών δεδομένων
                    του πελάτη, ο τελευταίος έχει την δυνατότητα να
                    ενημερωθεί σχετικά από την Πολιτική Απορρήτου της
                    Εταιρείας στον σύνδεσμο <a href={"www.zenith.gr/privacy/"}>www.zenith.gr/privacy/</a> .
                </li>
            </ul>
        </React.Fragment>
    )
}

function ProtectionLegalContainer({pack}) {
    switch (pack) {
        case '001':
            return (<CheckupProtectionLegal/>);
        case '002':
            return (<MaintenanceProtectionLegal/>);
        case '003':
            return (<PeaProtectionLegal/>);
        case '004': // yde
            return (<YdeProtectionLegal />);
        case '011': // new yde
            return (<YdeProtectionLegalNew />);
        default:
            return null;
    }
}

export default ProtectionLegalContainer;